<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="所在项目：" prop="pid1">
                <span>{{model.pid1}}</span>
            </el-form-item>
            <el-form-item label="关联类型：" prop="relation_type">
                <span>{{model.relation_type}}</span>
            </el-form-item>
            <el-form-item label="采集器设备ID：" prop="check_id">
                <span>{{model.check_id}}</span>
            </el-form-item>
            <el-form-item label="采集器出厂编号：" prop="check_factory_code">
                <span>{{model.check_factory_code}}</span>
            </el-form-item>
            <el-form-item label="采集器设备编号：" prop="check_code">
                <span>{{model.check_code}}</span>
            </el-form-item>
            <el-form-item label="记录仪设备ID：" prop="work_id">
                <span>{{model.work_id}}</span>
            </el-form-item>
            <el-form-item label="记录仪设备编号：" prop="work_code">
                <span>{{model.work_code}}</span>
            </el-form-item>
            <el-form-item label="非接触设备ID：" prop="extract_id">
                <span>{{model.extract_id}}</span>
            </el-form-item>
            <el-form-item label="非接触出厂编号：" prop="extract_factory_code">
                <span>{{model.extract_factory_code}}</span>
            </el-form-item>
            <el-form-item label="非接触设备编号：" prop="extarct_code">
                <span>{{model.extarct_code}}</span>
            </el-form-item>
            <el-form-item label="开始时间：" prop="start_time">
                <span>{{model.start_time}}</span>
            </el-form-item>
            <el-form-item label="结束时间：" prop="end_time">
                <span>{{model.end_time}}</span>
            </el-form-item>
            <el-form-item label="添加人ID：" prop="creator_id">
                <span>{{model.creator_id}}</span>
            </el-form-item>
            <el-form-item label="添加人名称：" prop="creator_name">
                <span>{{model.creator_name}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="更新人ID：" prop="update_id">
                <span>{{model.update_id}}</span>
            </el-form-item>
            <el-form-item label="更新人名称：" prop="update_name">
                <span>{{model.update_name}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deviceRelationTimeLogInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                relation_type: '',
                check_id: '',
                check_factory_code: '',
                check_code: '',
                work_id: '',
                work_code: '',
                extract_id: '',
                extract_factory_code: '',
                extarct_code: '',
                start_time: '',
                end_time: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/devicerelationtimelog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>